export default "__VITE_ASSET__arOtwWXx__"